<template>
  <div class="contentMain">
    <h1><p><i></i>录入图片&nbsp;&nbsp;<span>共{{localPic.length}}张图片</span></p>  
    </h1>
    <div class="piclist">
      <p>
        <el-upload
          class="uloadthere"
          :action="url"
          ref="upload"
          :before-upload="beforeAvatarUpload"
          :on-success='handleAvatarSuccess'
          :data="secbody"
          multiple
          :show-file-list="false"
          :on-error='uploadError'>
          <i class="el-icon-plus"></i>
        </el-upload>
      </p>
      <p v-loading='item.showshaow' v-for="item in localPic" :key="item.id">
        <span v-show="!item.isfalse">
          <img :src="item.url"/>
        </span>
        <span v-show='item.isfalse'>
          <img src="../../assets/img/uploadfild.png">
          <button @click='reupload(item.id)' class="reupload"><i v-if="item.btnshaow" class="el-icon-loading"></i>重试</button>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import axios from 'axios'
export default {
  name: 'knowledgeManagement',
  components: {},
  props: {},
  data() { 
    return {
    dialogImageUrl: '',
    dialogVisible: false,
    disabled: false,
    url:"#",
    secbody:{},
    //失败图片组
    defpiclist:[],
    //本地回显图片组
    localPic:[], //上传成功图片放置
    lodingPic:true,
    btnloading:false,
  } },
  computed: {},
  // 组件实例创建后
  created() {},
  // 组件挂载完成
  mounted() {},
  // 离开组件之前
  beforeDestroy() {},
  methods: {
    //上传前的方法，拿到上传url以及各种上传信息
    beforeAvatarUpload(file,isreload){
      //判断是不是第一次传输
      if(!isreload){
        //图片回显列表
        let json = {
          'url':window.URL.createObjectURL(file),
          'id':file.uid,
          'isfalse':false,
          'showshaow':true,
        }
        this.localPic.push(json);
      }
      //处理图片
      let spark = new SparkMD5();
      let fileReader = new FileReader();
      let that = this;
      fileReader.readAsBinaryString(file)
      fileReader.onload = function (e) {
        if (!e.target) return
        const result = e.target.result;
        spark.appendBinary(result);
        const md5value = spark.end();
        axios.get('https://cms.hexfuture.net/FileManagement/GetUploadUrl',{
          params: {
            ssotoken:that.$tools.getCookie("localtoken"),
            id:encodeURIComponent(md5value + '/' + '1.jpg')
          }
        })
        .then(res=>{
          var res=res.data
          //获取上传附加data以及上传地址
          that.url = res.Url
          that.secbody = res;
        })
      };
      return new Promise((resolve, reject)=>{
        setTimeout(()=>{
          this.$nextTick(()=>{
            resolve()
          });
        },400)
      })
    },
    //成功后，拿到返回的图片id
    handleAvatarSuccess(res, file){
      let xmlDoc = new DOMParser().parseFromString(res, "text/xml");
      let Bucket=xmlDoc.getElementsByTagName('Bucket')[0].innerHTML;
      let Key=xmlDoc.getElementsByTagName('Key')[0].innerHTML;
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      const json_id = {
        MIME: '',
        Name: Key,
        Path: Bucket,
        Property: "",
        Size: file.size,
        UploadType: "OSS",
        User: null
      }
      const formData2 = new FormData()
      formData2.append('id', JSON.stringify(json_id))
      axios.post(`https://cms.hexfuture.net/FileManagement/SaveResource?ssotoken=${this.$tools.getCookie("localtoken")}`,formData2,config)
      .then(res=>{
        console.log(res);
        //修改回显图片地址
        this.localPic.forEach(element => {
          if(element.id == file.uid){
            element.isfalse = false;
            element.url = 'https://dcms.hexfuture.net/FileManage/DownLoadImage?id='+res.data.ResourceID;
            element.realID = res.data.ResourceID;
            element.showshaow = false
          }
        });

      })
    },
    //拿到上传失败的所有图片
    uploadError(err, file, fileList){
      this.defpiclist.push(file.raw)
      this.localPic.forEach(element => {
        if(element.id == file.uid){
          element.showshaow = false
          setTimeout(()=>{
            element.isfalse = true;
          },200)
        }
      });
    },
    //重新上传
    reupload(errorpic){
     // this.btnloading = true;
     this.localPic.forEach(element => {
      if(element.id == errorpic){
        element.btnshaow = true;
      }
    });
      setTimeout(()=>{
        this.btnloading = false;
      },5000) 
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      //再次上传方法
      this.defpiclist.forEach(element => {
        if(element.uid == errorpic ){
          this.beforeAvatarUpload(element,1)
          const formData = new FormData()
          formData.append('Key', this.secbody.Key)
          formData.append('OSSAccessKeyId', this.secbody.OSSAccessKeyId)
          formData.append('Policy', this.secbody.Policy)
          formData.append('Signature', this.secbody.Signature)
          formData.append('Success_action_status', this.secbody.Success_action_status)
          formData.append('file', element)
          axios.post(this.url,formData,config)
          .then((res)=>{
            this.handleAvatarSuccess(res.data,element)
          })
        }
      });
    }
  },
}
</script>
<style lang='scss' scope>
.contentMain{
        width: 100%;
        padding: 0 10px;
        overflow-y: scroll;
        h1{
          display: flex;  
          font-weight: normal;
          justify-content: space-between;
          align-items: center;
          margin: 18px auto 16px;
          p{
              font-size: 16px;
              i{
                  display: inline-block;
                  width: 4px;
                  height: 16px;
                  background: #4B90E2;
                  border-radius: 2px;
                  position: relative;
                  top: 2px;
                  margin-right: 10px;
              }
          }
          span{
              font-size: 14px;
              color: #999999;
          }
          .el-button--danger{
                span{
                  color: #F56C6C !important;
              }
          }
      }
      .piclist{
        p{
          width: 240px;
          height: 380px;
          border: 1px dashed #DDDDDD;
          margin: 0px 0px 20px 20px;
          float: left;
          img{
            width: 100%;
          }
        } 
      }
    .reupload{
      width: 88px;
      height: 34px;
      background: #E13030;
      border-radius: 4px;
      color: #fff;
      margin: 20px auto 0;
      display: block;
    }
    .uloadthere{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(221, 221, 221, 0.4);
      border: 1px solid #DDDDDD;
      i{
        font-size: 60px;
        margin: 0 auto;
        color: #999999;
      }
    }
  }
  .el-icon-delete{
    display: none;
  }
</style>